<template>
  <div  class="homen1" style="width: 100%;margin: auto;min-height: 480px;padding-top: 40px;padding-bottom: 40px">
    <div class="wad" >   <div style="width: 1180px;margin: auto;margin-top: 20px;height: 300px;">
      <div style="width: 330px;float: left">
      <el-menu
      default-active="1"
      class="el-menu-vertical-demo"
      background-color="#008cff"
      text-color="#fff"
      active-text-color="#fff">
        <a  href='/lmbj' class='active' style="color: #ffffff">
      <el-menu-item index="1" class="elsubmenua">
        <span slot="title">建设背景</span>
      </el-menu-item>
         </a>
         <a  href='/lmzc' class='active' style="color: #ffffff">
      <el-menu-item index="2" class="elsubmenua">
         <span slot="title">联盟章程</span>
      </el-menu-item>
         </a>
      <el-menu-item index="3" class="elsubmenua">
        <span slot="title">联盟活动</span>
      </el-menu-item>
      <el-menu-item index="4" class="elsubmenua">
        <span slot="title">联盟拓展</span>
      </el-menu-item>
      <el-menu-item index="5" class="elsubmenua">
        <span slot="title">自媒体</span>
      </el-menu-item>
    </el-menu>
      </div>
       <div class="cxlmright">
   <div class="cxlmrightc" ><p>2016年7月5日工信部印发了《促进中小企业发展规划（2016－2020年）》，明确提出推进中小企业信用体系建设：
依托全国信用信息共享平台，推动建立中小企业信用信息共享机制。</p>
     <p>支持利用大数据以及各类信息资源，建立包括企业纳税信息、进销存信息、诚信经营信息等中小企业信用信息平台。</p>
     <p>鼓励各类平台畅通与银行业金融机构间的信用信息渠道，便于金融机构对中小企业进行评级及授信。</p>
     <p>鼓励各类信用服务机构提供有效服务，为中小企业融资提供便利。</p>
   </div>
         <div style="float: left"><img src="../../assets/img/gxbwz.png" style="margin: 2px 8px;
    width: 300px;
    border: 1px solid #dfdfdf;
    height: 274px;" height="100" width="100"/></div>
      </div>
      </div></div>
    <div class="wad" >   <div style="width: 1180px;margin: 20px auto 20px;">
      <div class="box-title1" style="margin-bottom: 20px;height: 50px">
      <div style="float: left"><strong>

        联盟共同发起单位

        </strong></div><img  src="../../assets/img/zxwlogo.png" height="35" width="196" style="float: left;margin-top: 10px"/>
      </div>
         <div style="margin: auto;width: 1000px" ><img  src="../../assets/img/logo1.png" height="130" width="1000"/></div>
       </div></div>
    <div class="wad" >  <div style="width: 1180px;margin: 20px auto 20px;">
      <div class="box-title1" style="margin-bottom: 20px;height: 50px">
      <div style="float: left">
        <strong>
        联盟副会长单位
        </strong>
      </div>
      </div>
     <div v-loading="loading" style="margin: auto;width: 1180px;min-height: 150px" >
           <ul style="width: 1180px;">
           <li style="        margin-top: 25px;
        padding: 10px;
    height: 116px;width: 369px;background: #ffffff"  v-for="(item,index) in list2" :key="index"  :index="item.path" >
             <div style="text-align: center;margin-bottom: 10px;padding: 5px"><img v-if="item.logo" :src="baseUrl+item.logo" style="width: 364px; height: 70px" alt=""></div>
             <div class="adsee" style="text-align: center"><router-link  :to="{path:'/news', query: { id: item.id }}" target="_blank">
               {{ item.title }}
           </router-link></div>
           </li>
            </ul>
         </div>
       </div></div>
    <div class="wad" > <div style="width: 1180px;margin: 20px auto 20px;">
      <div class="box-title1" style="margin-bottom: 20px;height: 50px">
      <div style="float: left">
        <strong>
        联盟理事成员单位
        </strong>
      </div>
      </div>
     <div v-loading="loading" style="margin: auto;width: 1180px;min-height: 150px" >
           <ul style="width: 1180px;">
           <li style="        margin-top: 25px;
    height: 135px;width: 275px"  v-for="(item,index) in list" :key="index"  :index="item.path" >
             <div style="text-align: center;border: 1px #afafaf solid;margin-bottom: 10px;padding: 5px"><img v-if="item.logo" :src="baseUrl+item.logo" style="width: 125px; height: 90px" alt=""></div>
             <div class="adsee" style="text-align: center"><router-link  :to="{path:'/news', query: { id: item.id }}" target="_blank">
               {{ item.title }}
           </router-link></div>
           </li>
            </ul>
         </div>
       </div></div>
    <div class="wad" style="margin-bottom: 0px">     <div style="width: 1180px;margin: 20px auto 20px;">
      <div class="box-title1" style="margin-bottom: 20px;height: 50px">
      <div style="float: left"><strong>

        联盟成员单位

        </strong></div>

      </div>
     <div v-loading="loading" style="margin: auto;width: 1180px" >
           <ul style="width: 1180px;">
           <li style="        margin-top: 25px;
    height: 105px;width: 339px;background: #ffffff;padding: 15px"  v-for="(item,index) in list1" :key="index"  :index="item.path" >
             <div style="text-align: left;border: 0px #afafaf solid;margin-bottom: 10px;padding: 5px;float: left;width: 105px;margin-right: 10px"><img v-if="item.logo" :src="baseUrl+item.logo" style="width: 95px; height: 85px;border: 1px #cccccc solid;padding: 5px" alt=""></div>
             <div class="adsee" style="text-align: left;margin-top: 5px;height: 95px;white-space: nowrap;

overflow: hidden;

text-overflow: ellipsis;"><a  :href="item.url" :title="item.title" target="_blank" style="height: 42px">
               {{ item.title }}<br><br><p>前往网站>></p>
           </a></div>
           </li>
            </ul>
         </div>
      </div></div>
<!--    查询版-->
  </div>
</template>

<script>
import { getAllianceList } from '@/api/alliance'
import Pagination from '@/components/Pagination'
export default {
  name: 'Home',
  components: {
    Pagination
  },
  data () {
    return {
      loading: true,
      baseUrl: 'http://credit.sme.com.cn/api',
      channel: [],
      list: null,
      list1: null,
      list2: null,
      listLoading: true,
      index: '',
      sortIndex: 0,
      carouselIndex: 0,
      currentPage: 1,
      limit: 10,
      total: 0,
      formInline: {
        eName: '',
        eName1: '',
        eName2: ''
      },
      rules: {
        eName: [
          { required: true, message: '请输入企业名称、统一社会信用代码或证书编号', trigger: 'blur' }
        ],
        eName1: [
          { required: true, message: '请输入企业名称、统一社会信用代码或证书编号', trigger: 'blur' }
        ],
        eName2: [
          { required: true, message: '请输入企业名称、统一社会信用代码或证书编号', trigger: 'blur' }
        ]
      },
      lv: 1
    }
  },
  created () {
    this.fetchData()
    this.fetchData1()
    this.fetchData2()
  },
  methods: {

    onSubmitxy (formInline) {
      var that = this
      var ename = that.formInline.eName
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          window.location.href = '/static/creditSearchAll.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
    },
    onSubmitrz () {
      var that = this
      var ename = that.formInline.eName1
      console.log(that.formInline)
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
      this.$refs.formInline.validate((valid) => {
        console.log(valid)
        if (valid) {
          window.location.href = '/static/rzcx.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onSubmitzz () {
      var that = this
      var ename = that.formInline.eName2
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          window.location.href = '/static/zzcx.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    onButton1 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 1
    },
    onButton2 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 2
    },
    onButton3 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 3
    },
    fetchData () {
      getAllianceList({ memberType: '0' }).then(response => {
        console.log(response)
        if (response.result === 1) {
          this.list = response.data
          this.loading = false
        }
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    fetchData1 () {
      getAllianceList({ memberType: '1' }).then(response => {
        if (response.result === 1) {
          this.list1 = response.data
        } this.loading = false
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    fetchData2 () {
      getAllianceList({ memberType: '2' }).then(response => {
        if (response.result === 1) {
          this.list2 = response.data
        } this.loading = false
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleSizeChange (val) {
      this.limit = val
      this.currentPage = 1
      this.fetchData()
    },
    handleClick (id) {
      window.location.href = '/static/xxgsjg.html' + '?entid=' + id
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
<style>
  .wad{
    width: 1230px;
    margin: 0px auto 30px;
    padding:10px 0  10px 0;
    background: #ffffff;
  }
  .homen1{background: #eeeeee;background-size:100% 100%;}
  .el-main{
    padding: 0px !important;
    /*background-color: #f5f5f500;*/

  }
   .listNews{
    height: 40px;
    width: 590px;
   margin-bottom: 8px;
    line-height: 35px;
    font-size: 28px;
    font-weight: bold;
    float: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #444444;
  }
  .listNews1{
    height: 40px;
    width: 590px;
   margin-bottom: 8px;
    line-height: 35px;
    font-size: 18px;
    font-weight: normal;
    float: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #555555;
  }
  .box-title1{    width: 100%;
    margin: auto;    border-bottom: 2px solid #e5e5e5;}
  .box-title1  strong {
    font-size: 20px ;
    margin-bottom: 8px;
    padding: 12px;
    line-height: 50px;
    height: 50px;
    border-bottom: 2px solid #cccccc;
    text-indent: 0.5em;
    color: #333333;

}
  .box-title1  strong a{
    color: #d80026;
    text-decoration: none;
    cursor: pointer;
  }
  .recommend4 a{    text-decoration: none;
    cursor: pointer;
  color: #555;
      white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;}
  .recommend4 li{line-height: 40px;width: 98%;overflow: hidden;text-overflow:ellipsis}
  .recommend3 li:nth-of-type(3n - 2) a, .recommend4 li:nth-of-type(6n - 5) a, .recommend5 li:nth-of-type(5n - 4) a, .recommend6 li:nth-of-type(6n - 5) a, .recommend7 li:nth-of-type(7n - 6) a {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    background: none;

}
    .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .searchbar{
    margin: auto;
    width: 800px;
    top: 50%;
  }
  .h1title{
    text-align:center;color: #1065c0;font-size: 30px;font-weight: 700;margin-bottom: 60px
  }
  .abb{
    width: 800px;
    margin: 0px auto 20px;
    text-align: center;

  }
  .homen .abb .el-button{
    border:0px !important;
    font-size: 22px !important;
    color: #409eff !important;
    font-weight: bold !important;
  }
    .homen .abb .el-button:hover{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff;
  }
      .homen .abb .el-button:visited{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
        .homen .abb .el-button:active{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
  .homen .abb .el-button:focus{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
  .bottonbanner{
    background: url(../../assets/img/backbanner.png) no-repeat center;background-size:100% 100%;
  }
  .elsubmenua{
    width: 330px;
    margin: 0px !important;
    border-bottom: 1px #ffffff solid;
    border-top: 1px #ffffff solid;
    text-align: center;
    padding-right: 20px;
    font-size: 24px !important;
    line-height: 46px;

  }
  .elsubmenua a{ text-decoration: none}
  .cxlmright{
    width: 814px;
    float: left;
    margin-left: 3%;
    height: 280px;
    background: url(../../assets/img/backcxa.png) no-repeat center;background-size:100% 100%;
  }
  .cxlmrightc{
    width: 470px;color: #fff;padding-left: 20px;
    float: left;
  }
  .cxlmrightc p{
    margin-bottom: 25px;
    font-size: 16px;
  }
  .adsee a{
text-decoration:none;
    color: #444444;
 font-weight: bold;

  }
</style>



// WEBPACK FOOTER //
// src/components/computer/cxlm.vue